import { __rest } from 'tslib';
import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React from 'react';
import classnames from 'classnames';
import { Flex, Heading, Body, Tabs, StatusChip } from '@cognite/cogs-core';

/**
 * @deprecated This component will be removed in v11 as link functionality is
 * no longer supported.
 * TODO(CGS-1720)
 */
var PageHeaderLink = function PageHeaderLink() {
  return jsx(Fragment, {});
};
/**
 * @deprecated This component will be removed in v11 as breadcrumbs
 * functionality is no longer supported.
 * TODO(CGS-1720)
 */
var PageHeaderBreadcrumbs = /*#__PURE__*/React.forwardRef(function () {
  return jsx(Fragment, {});
});
PageHeaderBreadcrumbs.displayName = 'PageHeader.Breadcrumbs';
var PageHeaderTitleAreaStatusChip = function PageHeaderTitleAreaStatusChip(_a) {
  var className = _a.className,
    statusProps = __rest(_a, ["className"]);
  if (statusProps.label) {
    return jsx("div", {
      className: className,
      children: jsx(StatusChip, Object.assign({
        status: "success",
        size: "x-small",
        variant: "outline"
      }, statusProps))
    });
  }
  return jsx(Fragment, {});
};
var PageHeaderTitleArea = function PageHeaderTitleArea(_ref) {
  var title = _ref.title,
    description = _ref.description,
    statusProps = _ref.statusProps;
  return jsxs(Flex, {
    direction: "column",
    className: "cogs-pageheader__titlearea",
    children: [jsx(PageHeaderTitleAreaStatusChip, Object.assign({
      className: "cogs-pageheader__header-statuschip-mobile"
    }, statusProps)), jsxs("div", {
      className: "cogs-pageheader__title-status",
      children: [jsx(Heading, {
        className: "cogs-pageheader__header-desktop cogs-pageheader__header-tablet",
        level: 4,
        children: title
      }), jsx(Heading, {
        className: "cogs-pageheader__header-mobile",
        level: 5,
        children: title
      }), jsx(PageHeaderTitleAreaStatusChip, Object.assign({
        className: "cogs-pageheader__header-statuschip-desktop"
      }, statusProps))]
    }), description && jsx(Body, {
      size: "medium",
      className: "cogs-pageheader__body",
      children: description
    }), jsx(PageHeaderTitleAreaStatusChip, Object.assign({
      className: "cogs-pageheader__header-statuschip-tablet"
    }, statusProps))]
  });
};
var PageHeaderNavigation = function PageHeaderNavigation(props) {
  var items = props.items,
    rest = __rest(props, ["items"]);
  return jsx(Tabs, Object.assign({}, rest, {
    className: classnames('cogs-pageheader__navigation-tabs', rest.className),
    hidePadding: true,
    children: items.map(function (_ref2) {
      var chip = _ref2.chip,
        icon = _ref2.icon,
        label = _ref2.label,
        tabKey = _ref2.tabKey;
      return jsx(Tabs.Tab, {
        chip: chip,
        tabKey: tabKey,
        label: label,
        iconLeft: icon
      }, tabKey);
    })
  }));
};
var PageHeaderActions = function PageHeaderActions(_a) {
  var children = _a.children,
    ref = _a.ref,
    rest = __rest(_a, ["children", "ref"]);
  return jsx(Flex, Object.assign({
    className: "cogs-pageheader__actions",
    ref: ref
  }, rest, {
    gap: 10,
    children: children
  }));
};

export { PageHeaderActions, PageHeaderBreadcrumbs, PageHeaderLink, PageHeaderNavigation, PageHeaderTitleArea };
